import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import ProductOptionSwatch from "./product-option-swatch";
import ProductOptionPreview from "./product-option-preview";

export default function ProductOptionSwatchesGroup({
  groupTitle,
  madeToOrder,
  optionValues,
  selectedOptionValue,
  selectedVariant,
  disabledOptionValues,
  variantsByOptionValue,
  unavailableOptionValues,
  waitlistOptionValues,
  updateOptionValue,
  optionName,
  enableSwatchPreview,
  disabledSwatchStyle,
  optionSize,
  setPreviewOpen,
}) {
  const optionInGroupSelected = optionValues.some(
    (optionValue) => optionValue.name === selectedOptionValue,
  );

  return (
    <div className="product-options__swatch-group">
      <div className="product-options__swatch-group-header">
        <div className="product-options__swatch-group-title">{groupTitle}</div>
        {madeToOrder && (
          <div className="product-options__swatch-group-subtitle">
            {window.localeStrings.product.made_to_order_time_estimate}
          </div>
        )}
      </div>
      <fieldset className="product-options__swatch-list">
        <legend className="visually-hidden">{groupTitle}</legend>
        {optionValues.map((optionValue) => (
          <ProductOptionSwatch
            key={optionValue.name}
            optionValue={optionValue}
            optionName={optionName}
            disabled={disabledOptionValues.includes(optionValue.name)}
            unavailable={unavailableOptionValues.includes(optionValue.name)}
            waitlist={waitlistOptionValues.includes(optionValue.name)}
            optionVariant={variantsByOptionValue.find(
              (variantByOptionValue) =>
                variantByOptionValue.optionValue === optionValue.name,
            )}
            updateOptionValue={updateOptionValue}
            selected={optionValue.name === selectedOptionValue}
            onClick={() => setPreviewOpen(true)}
            disabledSwatchStyle={disabledSwatchStyle}
            optionSize={optionSize}
          />
        ))}
      </fieldset>
    </div>
  );
}
